import { render, staticRenderFns } from "./DashDatePicker.vue?vue&type=template&id=1b6c8bf8&scoped=true"
import script from "./DashDatePicker.vue?vue&type=script&lang=js"
export * from "./DashDatePicker.vue?vue&type=script&lang=js"
import style0 from "./DashDatePicker.vue?vue&type=style&index=0&id=1b6c8bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6c8bf8",
  null
  
)

export default component.exports